import { render, staticRenderFns } from "./ModalRenderProtocolized.vue?vue&type=template&id=96f30b60&"
import script from "./ModalRenderProtocolized.vue?vue&type=script&lang=ts&"
export * from "./ModalRenderProtocolized.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports